export class User {
    id?: number;
    is_active?: boolean;
    is_deleted?: boolean;
    reset_password?: boolean;
    username?: string;
    email_address?: string;
    first_name?: string;
    last_name?: string;
    other_name?: string;
    roles?: Array<Role>;
}

export class Role {
    id!: number;
    is_active?: boolean;
    name?: string;

    constructor(id : number,is_active: boolean,name : string) {
        this.id=id;
        this.is_active=is_active;
        this.name=name;
    }
}

export class AuthenticatedUser extends User {
    authorities?: null;
    member_id?: null;
    identity_number?: null;
    phone_number?: null;
    is_primary?: true;
    agent_branch_id?: null;
    agent_id?: null;
    agent_rep_id?: null;
    regions?: null;
    pin_change_required?: false;
    app_versions?: any[];
}